var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"enctype":"multipart/form-data"},on:{"submit":function($event){$event.preventDefault();return _vm.saveProductImages.apply(null, arguments)}}},[_c('input',{ref:"productImages",attrs:{"disabled":_vm.access_level > 1,"multiple":_vm.multiple,"type":"file"},on:{"change":_vm.selectProductImages}})])
}
var staticRenderFns = []

export { render, staticRenderFns }